import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionSkeleton from './DiscussionSkeleton';
import HomeDiscussionsState from '../states/HomeDiscussionsState';
//import DiscussionListState from 'flarum/states/DiscussionListState';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default class HomeDiscussions extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		/**
		 * The discussion list state.
		 *
		 * @type {HomeDiscussionsState}
		 */
		//this.discussions = new DiscussionListState(
		this.discussions = new HomeDiscussionsState(
			this.defaultParams,
			1,
			this.limit,
			this.preloadedKey,
		);

		this.discussions.refresh();
	}

	get preloadedKey() {
		return this.attrs.preloadedKey ? this.attrs.preloadedKey : 'discussions';
	}

	get defaultParams() {
		const { params } = this.attrs;
		const defaultParams = { include: [], filter: {} };
		return {
			...defaultParams,
			...params,
		};
	}

	// for child classes
	getDefaultParams() {
		return this.defaultParams;
	}

	get limit() {
		return 3;
	}

	get baseClass() {
		return 'HomeDiscussions';
	}

	view() {
		return (
			<div className={this.baseClass}>
				<h2 class={`title-disc`}>
					<span>{this.titleText}</span>
				</h2>

				{this.button}

				{/* Show skeleton elements when loading */}
				{this.discussions.isInitialLoading() && (
					<ul className={`${this.baseClass}-discussions`}>
						{Array.from(Array(this.limit).keys()).map(this.skeletonItem)}
					</ul>
				)}

				{this.discussions.isEmpty() && <Placeholder text={this.emptyText} />}

				{this.discussions.hasItems() && (
					<ul className={`${this.baseClass}-discussions`}>
						{this.discussions.getAllItems().map(this.listItem)}
					</ul>
				)}
			</div>
		);
	}

	get button() {
		const { showBtn } = this.attrs;
		if (!showBtn) {
			return null;
		}

		const allowed = app.forum.attribute('canStartDiscussion') || !app.session.user;

		const prfx = 'core.forum.index';
		const label = t(
			allowed ? `${prfx}.start_discussion_button` : `${prfx}.cannot_start_discussion_button`,
		);

		return (
			<Button
				className='Button Button--large IndexPage-newDiscussion'
				itemClassName='App-primaryControl'
				onclick={IndexPage.prototype.newDiscussionAction.bind(IndexPage.prototype)}
				disabled={!allowed}>
				{label}
			</Button>
		);
	}

	get titleText() {
		const { title } = this.attrs;
		return title;
	}

	get emptyText() {
		return t('core.forum.discussion_list.empty_text');
	}

	listItem(discussion) {
		return (
			<li key={discussion.id()} data-id={discussion.id()}>
				<DiscussionListItem discussion={discussion} params={{}} />
			</li>
		);
	}

	skeletonItem() {
		return <DiscussionSkeleton />;
	}
}
